import { css } from "@compiled/react";
import { defineMessages, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { Logo } from "../../../libraries/wpl/foundations/src/index";

import { ComponentStyleProps } from "./global-footer-top";

// ==================================================================
// Style Functions
// ==================================================================
const logoColumnStyle = css({
    gridArea: "logo",
    border: "0",
    padding: "0",
    [media.above.md]: {
        position: "relative",
        minHeight: "1px"
    },
    [media.below.md]: {
        width: "100%"
    }
});

const logoColumnAnchorTagStyle = css({
    "color": "#42526e",
    "fontSize": "0.875rem",
    "lineHeight": "1.125",
    "textDecoration": "none",
    "marginBlockEnd": "0",
    "display": "block",
    "verticalAlign": "baseline",
    "& svg": {
        width: "125px",
        height: "auto",
        pointerEvents: "none",
        marginBlockEnd: "16px",
        verticalAlign: "bottom",
        maxWidth: "100%"
    }
});

const ComponentStyle = css(ComponentStyleProps);

// ==================================================================
// Rendering Functions
// ==================================================================
export const LogoLinkContainer = () => {
    const intl = useIntl();
    const messages = defineMessages({
        ariaLabelLogo: {
            id: "globalFooter.top.logo-label",
            defaultMessage: "Atlassian logo"
        }
    });

    const href = "/wac";

    //TODO: Figure out data event values
    const dataEvent = "some-random-data-event";
    const dataUuid = "some-random-data-uuid";
    const dataEventComponent = "some-random-data-event-component";
    const dataEventContainer = "some-random-data-event-container";
    const dataSchemaVersion = "1";

    return (
        <div css={logoColumnStyle}>
            <div css={ComponentStyle}>
                <a
                    css={logoColumnAnchorTagStyle}
                    aria-label={intl.formatMessage(messages.ariaLabelLogo)}
                    href={href}
                    data-event={dataEvent}
                    data-uuid={dataUuid}
                    data-event-component={dataEventComponent}
                    data-event-container={dataEventContainer}
                    data-schema-version={dataSchemaVersion}
                >
                    <Logo brand="atlassian" type="logo" appearance="neutral" />
                </a>
            </div>
        </div>
    );
};
